import { validateEndDate } from "src/main/Billing/Items/validators"
import * as yup from "yup"

import {
  ADD_NEW_BOAT,
  ADD_NEW_CONTACT,
} from "src/components/ContactSearch/constants"
import {
  contactBoatSchema,
  contactSchema,
} from "src/components/ContactSearch/contactAndBoatSchema"

import { SPACE_TYPES } from "./constants"

export const schema = yup
  .object()
  .shape({
    first_day: yup.date().required("First day is required."),
    last_day: yup
      .date()
      .required("Last day is required.")
      .test(
        "testing valid last day",
        "Last day is invalid",
        (lastDay, context) => {
          const invalid = validateEndDate({
            end: lastDay,
            start: context.parent?.first_day,
          })
          if (invalid) {
            return context.createError({
              message: "Must be the same as or later than first day.",
              path: "lastDay",
            })
          }
          return true
        }
      ),
    contact_boat_id: yup.string().required("Boat is required."),
    contact_boat: yup.object().when("contact_boat_id", {
      is: (contactBoatId) => contactBoatId === ADD_NEW_BOAT,
      then: () => contactBoatSchema,
    }),
    contact_id: yup.string().required("Contact is required."),
    contact: yup.object().when("contact_id", {
      is: (contactId) => contactId === ADD_NEW_CONTACT,
      then: () => contactSchema,
    }),
    special_request: yup.string(),
    space_type: yup
      .string()
      .oneOf(SPACE_TYPES.map((spaceType) => spaceType.value)),
  })
  .required()
